import React from "react"

export const SunIcon = () => (
  <svg
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    stroke="currentColor"
    viewBox="0 0 24 24"
    className="w-4 h-3 sm:h-4 text-gray-700"
  >
    <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
  </svg>
)

export const MoonIcon = () => (
  <svg
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    stroke="currentColor"
    viewBox="0 0 24 24"
    className="w-4 h-3 sm:h-4 text-gray-100"
  >
    <path d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
  </svg>
)

export const ConfirmedIcon = () => (
  <svg
    style={{ enableBackground: "new 0 0 512.004 512.004" }}
    viewBox="0 0 512.004 512.004"
    className="fill-current text-primary opacity-75 w-5 h-5 md:w-7 md:h-7"
  >
    <path d="m252 472.002h-211.059c7.936-84.1 65.351-157.444 145.865-184.682 20.766 10.662 44.29 16.682 69.194 16.682 83.813 0 152-68.187 152-152s-68.187-152-152-152-152 68.187-152 152c0 41.976 17.105 80.031 44.708 107.565-37.866 17.58-71.461 44.454-96.819 77.9-33.946 44.771-51.889 98.209-51.889 154.535 0 11.046 8.954 20 20 20h232c11.046 0 20-8.954 20-20s-8.954-20-20-20zm-108-320c0-61.757 50.243-112 112-112s112 50.243 112 112-50.243 112-112 112-112-50.243-112-112zm357.865 255.602c-9.552-5.417-21.664-2.109-27.159 7.37l-18.8-10.725c.674-3.594 1.043-7.294 1.043-11.08 0-3.683-.351-7.283-.99-10.784l18.575-10.63.192.328c3.718 6.37 10.413 9.922 17.292 9.922 3.423 0 6.893-.88 10.063-2.73 9.54-5.568 12.759-17.815 7.192-27.355l-19.881-34.064c-5.568-9.539-17.815-12.759-27.355-7.192-9.266 5.408-12.544 17.11-7.625 26.519l-18.38 10.518c-5.57-4.795-12.022-8.588-19.083-11.092v-20.607h.073c11.046 0 20-8.954 20-20s-8.954-20-20-20h-40c-11.046 0-20 8.954-20 20 0 11.021 8.915 19.957 19.927 19.996v20.61c-7.037 2.496-13.468 6.271-19.026 11.042l-18.293-10.468c4.919-9.409 1.641-21.111-7.624-26.519-9.541-5.567-21.787-2.348-27.354 7.192l-19.882 34.064c-5.568 9.54-2.348 21.787 7.191 27.355 3.17 1.85 6.639 2.73 10.063 2.73 6.879 0 13.575-3.553 17.292-9.922l.192-.329 18.444 10.554c-.647 3.525-1.003 7.15-1.003 10.859 0 3.813.373 7.538 1.056 11.155l-18.668 10.65c-5.495-9.478-17.606-12.786-27.159-7.37-9.608 5.448-12.981 17.654-7.533 27.263l19.882 35.064c3.682 6.493 10.449 10.139 17.417 10.139 3.342 0 6.731-.839 9.846-2.605 9.608-5.448 12.981-17.654 7.533-27.263l-.248-.437 19.075-10.882c5.505 4.679 11.858 8.384 18.798 10.845v22.277c-11.012.04-19.927 8.975-19.927 19.996 0 11.046 8.954 20 20 20h40c11.046 0 20-8.954 20-20s-8.954-20-20-20h-.073v-22.274c6.965-2.47 13.338-6.193 18.856-10.895l19.163 10.932-.247.436c-5.448 9.609-2.075 21.814 7.533 27.263 3.116 1.767 6.504 2.605 9.846 2.605 6.967 0 13.735-3.646 17.417-10.139l19.881-35.064c5.449-9.604 2.076-21.81-7.532-27.258zm-104.916 5.564c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20z" />
  </svg>
)

export const DeceasedIcon = () => (
  <svg
    viewBox="0 0 512 512"
    className="fill-current text-primary opacity-75 w-5 h-5 md:w-7 md:h-7"
  >
    <g>
      <path d="m448 456h-16v-16a8 8 0 0 0 -8-8h-8v-264c0-88.22-71.78-160-160-160s-160 71.78-160 160v264h-8a8 8 0 0 0 -8 8v16h-16a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8zm-336-288c0-79.4 64.6-144 144-144s144 64.6 144 144v264h-288zm-16 280h320v8h-320zm344 40h-368v-16h368z" />
      <path d="m328 120h-48v-40a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v40h-48a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h48v104a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-104h48a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8zm-8 32h-48a8 8 0 0 0 -8 8v104h-16v-104a8 8 0 0 0 -8-8h-48v-16h48a8 8 0 0 0 8-8v-40h16v40a8 8 0 0 0 8 8h48z" />
      <path d="m328 320h-144a8 8 0 0 0 -8 8v64a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-64a8 8 0 0 0 -8-8zm-8 64h-128v-48h128z" />
    </g>
  </svg>
)

export const RecoveredIcon = () => (
  <svg
    viewBox="0 0 512 512"
    className="fill-current text-primary opacity-75 w-5 h-5 md:w-7 md:h-7"
  >
    <path d="M404.566,292.931a36.319,36.319,0,0,0-29.334,14.91,36.306,36.306,0,0,0-29.343-14.934c-12.078,0-21.918,4.977-28.455,14.392-5.083,7.32-7.883,17.1-7.883,27.525,0,45.033,59.347,83.961,61.873,85.6a7,7,0,0,0,7.624-.012c2.526-1.645,61.856-40.817,61.856-85.591C440.9,314.513,428.169,292.931,404.566,292.931Zm-29.35,113.09c-12.545-9-51.665-39.618-51.665-71.2,0-4.662,1.077-27.917,22.338-27.917a22.371,22.371,0,0,1,22.338,22.356,7,7,0,1,0,14,0,22.361,22.361,0,0,1,22.339-22.332c16.274,0,22.338,17.105,22.338,27.887C426.9,366.207,387.758,396.972,375.216,406.021Z" />
    <path d="M375.229,239.343a118.019,118.019,0,0,0-105.936,66.211c-1.082-.337-2.128-.667-3.117-.988L257.352,284.7c20.856-15.808,26.583-40.318,28.15-52.207,14.178-3.835,27.207-20.5,32.426-42.58,2.808-11.932-1.305-23.039-10.237-27.642a17.281,17.281,0,0,0-8.034-1.94c.464-3.472.947-7.721,1.448-12.944,1.167-12.179,1.912-24.48,1.912-27.6,0-13.04-4.441-32.829-16.9-49.263-20.738-27.344-53.466-33.083-77.27-33.083-23.414,0-55.951,5.354-77.991,30.859-17.352,20.08-21.124,44.6-19.427,56.185.062.419.435,2.393,1.031,5.34a7,7,0,0,0,.192,1.149c.016.06.065.241.145.507,1.526,7.435,4.13,19.4,6.821,29.3a17.672,17.672,0,0,0-6.945,2.1c-8.574,4.634-12.505,15.5-9.783,27.036,5.227,22.121,18.293,38.8,32.5,42.6,1.673,11.555,7.484,35.512,27.4,51.342l-9.413,20.29c-6.658,2.08-13.978,4.12-21.728,6.262C84.085,323.561,19,341.57,19,401.479v43.2C19,459.318,37.788,475,51.09,475H370.36c1.616.066,3.237.108,4.869.108a117.883,117.883,0,1,0,0-235.765ZM141.444,77.459c14.915-17.261,37.591-26.013,67.4-26.013,30.01,0,52.255,9.267,66.116,27.543a69.053,69.053,0,0,1,11.019,21.866A93.016,93.016,0,0,0,264.4,83.528a6.947,6.947,0,0,0-10.118,4.281c-.081.28-8.7,28.333-63.1,52.934-20.351,9.2-36.752,11.015-48.751,5.385a31.556,31.556,0,0,1-16.241-18.687l-.008-.026c-.433-2.151-.75-3.874-.909-4.955C122.787,105.476,135.094,84.807,141.444,77.459Zm7.307,148.589a7.048,7.048,0,0,0-7-6.719l-.28,0c-8.36,0-20.332-13.036-24.962-32.629-1.435-6.083.453-10.226,2.815-11.5,2.676-1.446,5.524,1.093,6.624,2.253a7,7,0,0,0,10.813-8.833c-.85-1.574-2.2-6.026-3.679-11.606,1,.583,2.044,1.14,3.139,1.663a49.639,49.639,0,0,0,21.643,4.635c11.559,0,24.629-3.274,39.088-9.813,43.133-19.507,60.478-41.645,67.089-53.508a82.168,82.168,0,0,1,9.028,7.651c9.813,9.655,14.806,19.737,14.85,29.968-1.037,12.655-2.639,27.669-4.066,31.314a7,7,0,0,0,11.192,8.336c1.3-1.48,3.834-3.775,6.233-2.541,2.59,1.334,4.459,5.881,3.022,11.981-4.658,19.713-16.744,32.774-25.109,32.63a7.005,7.005,0,0,0-7.132,6.8c-.3,5.761-3.034,35.248-27.093,50.12-9.333,5.764-20.961,8.686-34.561,8.686-13.553,0-25.151-2.986-34.475-8.878C152.3,261.141,149.144,231.781,148.751,226.048Zm16.034,86.782,9.949-21.449c10.293,5.013,22.254,7.555,35.672,7.555,13.065,0,24.745-2.351,34.843-6.993l9.392,21.141a7,7,0,0,0,4.161,3.792c1.594.537,3.273,1.084,5.077,1.653q-1.68,4.82-2.948,9.819c-7.609,13.887-25.219,29.773-50.525,29.773-33.019,0-49.744-25.925-53.105-40.532,1.115-.347,2.218-.7,3.3-1.048A7,7,0,0,0,164.785,312.83ZM51.09,461C44.455,461,33,450.628,33,444.679v-43.2c0-21.887,10.315-38.322,32.582-51.721,20.154-12.128,46.5-19.419,69.77-25.853,2.9-.8,5.72-1.587,8.5-2.368,5.245,21.294,27.871,50.584,66.559,50.584a70.886,70.886,0,0,0,46.973-17.672c-.022.923-.037,1.848-.037,2.777a117.984,117.984,0,0,0,62,103.774Zm324.139.108-.167,0a6.985,6.985,0,0,0-1.175-.106H370.6a103.778,103.778,0,1,1,4.628.108Z" />
  </svg>
)

export const ChartIcon = ({ classes }: { classes: string }) => (
  <svg
    className={`stroke-current ${classes} w-5 h-5 md:w-8 md:h-8`}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
    />
  </svg>
)

export const MapIcon = ({ classes }: { classes: string }) => (
  <svg
    className={`stroke-current ${classes} w-5 h-5 md:w-8 md:h-8`}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
    />
  </svg>
)

export const ListIcon = ({ classes }: { classes: string }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    className={`stroke-current ${classes} w-5 h-5 md:w-8 md:h-8`}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
  </svg>
)

export const Downtrend = () => (
  <svg
    className="fill-current w-7 h-7 md:w-10 md:h-10 text-green-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
    />
  </svg>
)

export const Uptrend = () => (
  <svg
    className="fill-current w-7 h-7 md:w-10 md:h-10 text-red-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
    />
  </svg>
)

export const SortAcs = () => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    className="h-5 w-5 text-secondary"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15l7-7 7 7"
    />
  </svg>
)

export const SortDesc = () => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    className="h-5 w-5 text-secondary"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
)
